module.exports = __webpack_public_path__ + "static/social-share-ef95920e5d6578df6eb5d3c70dff4a3f.jpg";